// eslint-disable-next-line no-restricted-imports
import ReactAsyncSelect from 'react-select/async'

import { DOM_IDS } from '@/lib/constants'

// A wrapper around react-select's default <Select /> component with some
// app-specific defaults. Use this in all places instead of react-select's
// default export
const AsyncSelect: typeof ReactAsyncSelect = (props) => {
  return (
    <ReactAsyncSelect
      menuPortalTarget={document.getElementById(DOM_IDS.reactSelectPortal)}
      menuPosition="fixed"
      {...props}
    />
  )
}

export default AsyncSelect
